import { useState, useEffect } from 'react';

function getStorageValue(key: string, defaultValue: any, forceOverwrite) {
    // getting stored value
    if (typeof window !== 'undefined') {
        const saved = localStorage.getItem(key);
        const initial = saved !== null && !forceOverwrite ? JSON.parse(saved) : defaultValue;
        return initial;
    }
}

export const useLocalStorage = (key: string, defaultValue: any, forceOverwrite = false) => {
    const [value, setValue] = useState(() => {
        return getStorageValue(key, defaultValue, forceOverwrite);
    });

    useEffect(() => {
        // storing input name
        localStorage.setItem(key, JSON.stringify(value));
    }, [key, value]);

    return [value, setValue];
};
